<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator';
    import draggable from 'vuedraggable';

    // view
    //+ https://sortablejs.github.io/Vue.Draggable/#/simple
    //+ https://github.com/SortableJS/Vue.Draggable
    //+ for more information
    @Component({
        name: 'AppDraggable',
        mixins: [draggable],
    })
    export default class AppDraggable extends Vue
    {
    }
</script>